<template>
  <el-drawer
    ref="drawer"
    :title="config.title"
    :before-close="handleClose"
    :visible.sync="drawer"
    direction="rtl"
    custom-class="edit_drawer"
    :wrapper-closable="false"
  >
    <div v-loading="loading.detail" class="drawer__content">
      <el-form
        ref="form"
        :model="details"
        class="edit_form"
      >
        <formItem :field="fields" :form="details" />
      </el-form>
      <div class="drawer__footer">
        <el-button
          class="btn_item"
          :loading="loading.delete"
          @click="handleClose"
        >
          取 消
        </el-button>
        <el-popover
          v-if="!isAuth"
          v-model="visible"
          placement="top"
          width="160"
          class="btn_item"
        >
          <p>删除主体数据后将不可恢复</p>
          <div style="text-align: right; margin: 0">
            <el-button
              size="mini"
              type="text"
              :loading="loading.delete"
              @click="visible = false"
            >
              取消
            </el-button>
            <el-button
              type="primary"
              size="mini"
              :loading="loading.delete"
              @click="handleDelete(details)"
            >
              确定
            </el-button>
          </div>
          <el-button
            slot="reference"
            :loading="loading.delete"
            type="danger"
          >
            删除
          </el-button>
        </el-popover>
        <el-button
          v-if="!isAuth"
          class="btn_item"
          type="primary"
          :loading="loading.delete"
          @click="handleEdit()"
        >
          编辑
        </el-button>
      </div>
    </div>
    <editDialog ref="editDialog" @reset="handleReset" />
  </el-drawer>
</template>

<script>
import { mainManageDetail, mainManageDelete } from '@/api/principal';
import formItem from '@/views/configure/ownerRuleConfig/components/formItem.vue';
import { localStorageGet } from '@/utils/localStorage';
import { USER } from '@/constant/storage';
import editDialog from './editDialog.vue';
import { AuthStatus, authInfoField } from '../constant';

export default {
  name: 'DetailDialog',
  components: {
    formItem,
    editDialog,
  },
  props: {
    isViewAuthUser: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      drawer: false,
      loading: {
        delete: false,
        detail: false,
      },
      details: {},
      config: {
        fields: {},
      },
      visible: false,
    };
  },
  computed: {
    isAuth() {
      return this.details.authStatus === AuthStatus.AUTHED;
    },
    fields() {
      return this.details.authStatus === AuthStatus.AUTHED && this.isViewAuthUser ? [...this.config.fields.details, authInfoField] : this.config.fields.details;
    },
  },
  methods: {
    show(config) {
      this.config = config;
      this.getDetails();
      this.drawer = true;
    },
    async getDetails() {
      this.loading.detail = true;
      try {
        const res = await mainManageDetail({ id: this.config.id });
        this.details = res;
        this.loading.detail = false;
      } catch (error) {
        this.loading.detail = false;
      }
    },
    handleReset() {
      this.getDetails();
      this.$emit('reset');
    },
    handleClose() {
      this.details = {};
      this.drawer = false;
      this.visible = false;
    },
    async handleDelete(row) {
      this.loading.delete = true;
      const userInfo = localStorageGet(USER);
      try {
        await mainManageDelete({
          ids: [row.id],
          operatorUserId: userInfo.userId,
          operatorUserName: userInfo.ext?.oaUserName,
        });
        this.loading.delete = false;
        this.$message.success('删除成功');
        this.handleClose();
        this.$emit('reset');
      } catch (error) {
        this.loading.delete = false;
      }
    },
    handleEdit() {
      this.$refs.editDialog.show({
        title: this.config.title, form: { ...this.details }, mainType: this.config.mainType, fields: this.config.fields.edit,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
 ::v-deep .edit_drawer {
 .el-drawer__body{
  padding: 0 !important;
}
}
.drawer__content{
  height: 100%;
  padding: 24px;
}
::v-deep .edit_form{
  .el-form-item__label{
    text-align: left;
  }
}
.drawer__footer{
  background: #fff;
  position: absolute;
  bottom: 0;
  left: 0;
  padding: 16px 24px;
  width: calc(100% - 48px);
  border-top: 1px solid #EBEEF5;
  text-align: right;
}
.btn_item{
  margin-right:12px ;
}
</style>
